import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Section } from "@/components/common/kit";
import DataTable from "@/components/common/DataTable";
import { DateRangeFilter, SalesmanSelect, useRange } from "@/components/common/Filters";

export const COLL_COLS = [
  { key: "date", label: "Date", type: "date" }, { key: "salesman", label: "Salesman" },
  { key: "sales_value", label: "Sales Value", type: "money" }, { key: "gpay", label: "GPay/UPI", type: "money" },
  { key: "expenses", label: "Expenses", type: "money" }, { key: "expected_cash", label: "Expected Cash", type: "money" },
  { key: "cash", label: "Actual Cash", type: "money" }, { key: "difference", label: "Difference", type: "money" },
  { key: "receivable", label: "Receivable", type: "money" }, { key: "surplus", label: "Surplus", type: "money" },
];

export default function Collections() {
  const nav = useNavigate();
  const [range, setRange] = useRange("today");
  const [sid, setSid] = useState("");
  const { data, loading } = useFetch("/reports/collections", { date_from: range.from, date_to: range.to, salesman_id: sid || undefined });
  return (
    <div className="space-y-6">
      <PageHeader title="Collections" subtitle="Cash & GPay/UPI reconciliation from submitted day closures" />
      <div className="flex flex-wrap gap-2"><DateRangeFilter value={range} onChange={setRange} /><SalesmanSelect value={sid} onChange={setSid} allowAll /></div>
      <Section>
        <DataTable columns={COLL_COLS} rows={data || []} loading={loading} onRowClick={(r) => nav(`/admin/day/${r.salesman_id}/${r.date}`)}
          totals={["sales_value", "gpay", "expenses", "expected_cash", "cash", "difference", "receivable", "surplus"]}
          title="Collection Report" subtitle={`${range.from} to ${range.to}`} exportable testid="collections-table" emptyText="No submitted closures in this period." />
      </Section>
    </div>
  );
}
